"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLowerCase = exports.camelCaseToKebabCase = exports.kebabCaseToCamelCase = void 0;
function kebabCaseToCamelCase(str) {
    return str
        .split('-')
        .map(function (word, index) { return (index ? capitalizeFirstChar(word) : word); })
        .join('');
}
exports.kebabCaseToCamelCase = kebabCaseToCamelCase;
function camelCaseToKebabCase(str) {
    return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.camelCaseToKebabCase = camelCaseToKebabCase;
function isLowerCase(str) {
    return /^[a-z]*$/.test(str);
}
exports.isLowerCase = isLowerCase;
function capitalizeFirstChar(str) {
    if (!str) {
        return str;
    }
    var firstChar = str[0].toUpperCase();
    return "".concat(firstChar).concat(str.slice(1));
}
//# sourceMappingURL=wordsCase.js.map